import { useMutation } from 'react-query';
import { network } from 'services/network';

export const mutationFn = ({ riskId }: QueryParams) => {
    const url = `api/bo/deleteRiskRegister`;
    return network.post(url, riskId).then((response) => response.data);
};

export const useMutationDeleteRiskRegister = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    riskId: number[];
}
